import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import Title from 'Components/ComponentLibrary/Atoms/Text/Title';
import Subtitle from 'Components/ComponentLibrary/Atoms/Text/Subtitle';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import WizardStandardHeader from 'Components/ComponentLibrary/Components/Uncategorized/WizardStandardHeader';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import { wizardClasses } from 'Views/Page/Content/Templates/WizardTemplates/wizardCommonStyles';
import WizardSpecificPageLinkBottom
  from 'Components/ComponentLibrary/Components/Uncategorized/WizardSpecificPageLinkBottom';
import RichTextDisplay from 'Components/UI/RichTextDisplay';
import LinkIcon from '@material-ui/icons/Link';


const useStyles = makeStyles(theme => ({
  root: {
    ...wizardClasses.root(theme),
    margin: 0,
    height: '100vh',
  },
  container: {
    ...wizardClasses.container(theme),
    flexGrow: 1,
    textAlign: 'center',
  },
  title: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    fontWeight: theme.typography.fontWeightBold,
    marginBottom: theme.spacing(3.5),
  },
  upload: {
    marginTop: theme.spacing(3),
    width: '100%',
  },
  navigation: {
    position: 'sticky',
    bottom: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
    flexDirection: 'column',
    paddingBottom: theme.spacing(4),
  },
  linkIcon: {
    borderRadius: '50%',
    backgroundColor: theme.palette.facet.accentRed4,
    color: theme.palette.facet.red,
    padding: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: 88,
  },
  linkIconRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));

const ApexFundingAccountRejectedStepTemplate = ({ className }) => {
  const history = useHistory();

  const {
    pageContentResource: resource,
    loadPageContentLink,
  } = usePageContentContext();

  const classes = useStyles();

  const onClose = async () => {
    const link = resource.withRelationship(
      fr.relationships.specificPageLink.name,
      (rel) => rel.link('related'),
      () => history.push('/'),
    );

    if (link) {
      await loadPageContentLink(link);
    }
  };


  const handlePageBottomLinkClick = async () => {
    await loadPageContentLink(resource.relationship(fr.relationships.specificPageLink.name).link('related'));
  };


  return (
    <Box className={classNames(classes.root, className)}>
      <WizardStandardHeader
        color={'primary'}
        title={resource.attr('moduleName')}
        onClose={onClose}
      />
      <Box className={classes.container}>
        <Title className={classes.title} text={resource.attr('title')} test={'wizard-step-title'} />
        <Subtitle className={classes.subtitle} text={resource.attr('subtitle')} test={'wizard-step-subtitle'} />
        <div className={classes.linkIconRow}>
          <div className={classes.linkIcon}>
            <LinkIcon style={{ fontSize: 40 }} />
          </div>
        </div>
        <RichTextDisplay
          content={resource.attr('message')}
        />
      </Box>
      <Box className={classes.navigation}>
        <WizardSpecificPageLinkBottom
          resource={resource}
          onClick={handlePageBottomLinkClick}
        />
      </Box>
    </Box>
  );
};
ApexFundingAccountRejectedStepTemplate.defaultProps = {
  className: '',
};
ApexFundingAccountRejectedStepTemplate.propTypes = {
  className: PropTypes.string,
};

export default ApexFundingAccountRejectedStepTemplate;
